export default __webpack_public_path__ + "static/media/gallery-wip-emitter_02.b243db24.jpg";